'use client'

import { useAuth } from '@clerk/nextjs'
import { usePathname } from 'next/navigation'
import posthog from 'posthog-js'
import { useEffect, useRef } from 'react'
import {
  observeSignup,
  SIGNUP_DIAGNOSTIC_EVENT,
  SIGNUP_DIAGNOSTIC_MARKER,
  SIGNUP_DIAGNOSTIC_TTL,
  signupRoute,
} from '@/lib/observability/signup-diagnostics'

export function SignupDiagnostics() {
  const pathname = usePathname()
  const { isLoaded } = useAuth()
  const loaded = useRef(false)
  useEffect(() => {
    loaded.current = isLoaded
  }, [isLoaded])

  useEffect(() => {
    const route = signupRoute(pathname ?? '')
    try {
      if (route === 'signup') {
        sessionStorage.setItem(SIGNUP_DIAGNOSTIC_MARKER, String(Date.now()))
      } else {
        const value = sessionStorage.getItem(SIGNUP_DIAGNOSTIC_MARKER)
        sessionStorage.removeItem(SIGNUP_DIAGNOSTIC_MARKER)
        const age = value ? Date.now() - Number(value) : Number.NaN
        if (age >= 0 && age < SIGNUP_DIAGNOSTIC_TTL) {
          posthog.capture(SIGNUP_DIAGNOSTIC_EVENT, {
            diagnostic_version: 1,
            stage: 'destination_reached',
            route,
          })
        }
      }
    } catch {
      // Storage and analytics are optional; authentication is not.
    }
    if (route !== 'signup') return
    return observeSignup(
      () => ({
        auth_loaded: loaded.current,
        form_present: Array.from(document.querySelectorAll('.cl-signUp-root input')).some(
          (input) => input.getClientRects().length > 0,
        ),
      }),
      (properties) => posthog.capture(SIGNUP_DIAGNOSTIC_EVENT, properties),
    )
  }, [pathname])

  return null
}
